var ready = (callback) => {
    if (document.readyState != "loading") callback();
    else document.addEventListener("DOMContentLoaded", callback);
}

ready(() => { 
    const variants = document.querySelector('.card-product__quickadd-variants');
    const input = variants.parentElement.querySelector('product-form input[name="id"]');
    const buttons = variants.querySelectorAll('.main-blog__tag');
    
    buttons.forEach(button => {
        button.addEventListener('click', (e) => {
            buttons.forEach(otherTag => {
                if (otherTag !== e.currentTarget) {
                    otherTag.classList.remove('active');
                }
            });
            e.currentTarget.classList.add('active');
            const variant_id = e.currentTarget.getAttribute('data-id');
            input.value = variant_id;
        });
    });
    
});